module.exports = __webpack_public_path__ + "img/3.e656261c.jpg";